const initBlock = function( $block ) {
	$( '.js-job-application' ).on( 'shown.bs.modal', function() {
		let $modal = $( this );
		if ( !$modal.attr( 'data-init-modal-observe' ) ) {
			let fileLoadField = $modal.find( '.file_upload-container .files_uploaded' )[0];
			let config = {
				childList: true,
			};

			let fileLoadObserver = new MutationObserver( ( mutation ) => {
				if ( mutation[0].addedNodes.length ) {
					$modal.find( '.file_upload-container .nf-fu-fileinput-button span' ).text( 'Replace Resume' );
					$modal.find( '.file_upload-container .nf-fu-fileinput-button' ).addClass( 'file-loaded' );
				} else {
					$modal.find( '.file_upload-container .nf-fu-fileinput-button span' ).text( 'Add Resume' );
					$modal.find( '.file_upload-container .nf-fu-fileinput-button' ).removeClass( 'file-loaded' );
				}
			} );

			fileLoadObserver.observe( fileLoadField, config );
			$modal.attr( 'data-init-modal-observe', 'true' );
		} else {
			return;
		}
	} );

	const classBtnLoading = 'is-loading';
	const classBtnHidden = 'button--hidden';
	const classContainerLoading = 'is-loading';
	const selectorLoadMoreBtn = '.js-load-positions';
	const selectorPostsContainer = '.section-open-positions__content';
	const selectorBtnLabel = '.btn__label';

	const loadMoreVacBtn = $block.find( selectorLoadMoreBtn );
	const vacanciesContainer = $block.find( selectorPostsContainer );

	loadMoreVacBtn.on( 'click', e => {
		e.preventDefault();
		loadMoreVacancies();
	} );

	function loadMoreVacancies( customRequestUrl = false ) {
		const label = loadMoreVacBtn.find( selectorBtnLabel );
		const labelDefault = loadMoreVacBtn.attr( 'data-label-default' );
		const labelLoading = loadMoreVacBtn.attr( 'data-label-loading' );

		let requestUrl = customRequestUrl || loadMoreVacBtn.attr( 'href' );
		const replacePosts = !!customRequestUrl;

		vacanciesContainer.addClass( classContainerLoading );
		loadMoreVacBtn.addClass( classBtnLoading );
		label.html( labelLoading );

		$.get( requestUrl, response => {
			const $response = $( response );
			const html = $response.find( selectorPostsContainer ).html();

			if ( !html ) {
				vacanciesContainer.removeClass( classContainerLoading );
				loadMoreVacBtn.removeClass( classBtnLoading );
				label.html( labelDefault );
				return;
			}

			replacePosts ? vacanciesContainer.html( html ) : vacanciesContainer.append( html );

			history.pushState( {}, '', requestUrl );

			const $newButton = $response.find( selectorLoadMoreBtn );
			if ( !$newButton.length || $newButton.hasClass( classBtnHidden ) ) {
				loadMoreVacBtn.addClass( classBtnHidden );
			} else {
				loadMoreVacBtn.attr( 'href', $newButton.attr( 'href' ) ).removeClass( classBtnHidden );
			}

			vacanciesContainer.removeClass( classContainerLoading );
			loadMoreVacBtn.removeClass( classBtnLoading );
			label.html( labelDefault );

			vacancyModals();
		} );
	}

	const vacancyModals = () => {
		const $modalBtn = $block.find( '.vacancies-item__button' );
		if ( !$modalBtn.length ) {
			return false;
		}

		$modalBtn.on( 'click', function( e ) {
			e.preventDefault();
			const $this = $( this );
			const vacancyID = $this.attr( 'data-vacancy-id' );
			const vacancyPosition = $this.attr( 'data-vacancy-position' );

			const $modalVacancy = $( '#position-popup-0' );
			const $modalContent = $modalVacancy.find( '.modal-vacancies__content' );
			const $spinner = $modalVacancy.find( '.loading-spinner-wrap' );
			const $modalContentWrapper = $modalVacancy.find( '.modal-content' );

			$modalContentWrapper.hide();
			$spinner.show();
			$modalVacancy.modal( 'show' );

			$.ajax( {
				url: window.vacancyAjaxParams.ajax_url,
				type: 'POST',
				data: {
					action: window.vacancyAjaxParams.ajax_action,
					nonce: window.vacancyAjaxParams.nonce,
					vacancyId: vacancyID
				},
				success: function( response ) {
					if ( response.success ) {
						const vacancyPopupHTML = response.data;
						$modalContent.html( vacancyPopupHTML );
						$spinner.hide();
						$modalContentWrapper.fadeIn( 100 );

						if ( vacancyPosition && vacancyPosition.length > 0 ) {
							const setVacancyPosition = function() {
								const $hiddenField = $( '.modal-job-application input[type="hidden"]' );
								if ( $hiddenField.length ) {
									$hiddenField.val( vacancyPosition );
									$hiddenField.trigger( 'change' );
								}
							};

							setTimeout( setVacancyPosition, 100 );

							$( document ).one( 'nfFormReady', setVacancyPosition );
						}
					} else {
						console.error( response.data );
						$spinner.hide();
					}
				},
				error: function( xhr, status, error ) {
					console.error( 'AJAX error:', error );
					$spinner.hide();
				},
			} );
		} );
	};
	vacancyModals();
};

app.loadBlock( initBlock, 'open-positions', '.section-open-positions' );

if ( module.hot ) {
	module.hot.accept();
}
